import React from 'react'

import { useParams, useNavigate } from 'react-router-dom'
import { useTheme } from 'styled-components'

import { useFindTask } from '@hooks/task/find'
import { useRoles } from '@hooks/roles'
import { NoContent } from '@screens/Task/components/NoContent'
import { Section } from '@screens/Task/components/Section'

import { ResourcesCard } from './Card'

export function AssignmentsSection() {
  const theme = useTheme()
  const { taskId } = useParams<{ taskId: string }>()

  const { data: rawTask } = useFindTask(Number(taskId))
  const task = rawTask ?? ({} as NonNullable<typeof rawTask>)

  const navigate = useNavigate()
  const { readOnlyUserRoles, isUserAllowed } = useRoles()
  const isReadOnlyUser = isUserAllowed(readOnlyUserRoles)

  const assignments = rawTask ? task.assignments.sort() : []

  const hasAssignments = assignments.length > 0

  const handleOpenEditResourceForm = (id: number) => {
    navigate(`/task/${task.id}/edit-assignment/${id}`)
  }

  const resourceActions = isReadOnlyUser
    ? []
    : [
        {
          title: 'Add Resource',
          onPress: () => navigate(`/task/${taskId}/add-assignment`),
        },
      ]

  return (
    <Section title="Resources" actions={resourceActions}>
      {hasAssignments ? (
        <div style={{ display: 'flex', overflowX: 'auto', gap: '8px' }}>
          {assignments.map((item) => (
            <ResourcesCard
              onPress={() => handleOpenEditResourceForm(item.id)}
              key={item.id}
              resource={item}
              isReadOnly={isReadOnlyUser}
            />
          ))}
        </div>
      ) : (
        <NoContent
          backgroundColor={theme.colors.foregroundPaper}
          type="resources"
          message="No Resources to be displayed"
        />
      )}
    </Section>
  )
}
